(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-popup"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-subscribe-benefits"] && !window.DesignMode) return;
  try {
    
const carouselConfig = {
  slidesPerView: 3,
  spaceBetween: 10,
  loop: true,
  centeredSlides: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  freeMode: false,
  watchSlidesProgress: true,
  breakpoints: {
    0: {
      slidesPerView: 3,
      spaceBetween: 8,
    },
    480: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 10,
    }
  }
};


function isMobile() {
  try {
    return window.innerWidth <= 767;
  } catch (e) { null; }
}


function carouselExists() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    return carouselElement && carouselElement.swiper;
  } catch (e) { null; }
}


function initializeCarousel() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    
    if (!carouselElement) {
      return null;
    }

    if (typeof Swiper === 'undefined') {
      return null;
    }

    const carousel = new Swiper('#benefits-carousel', carouselConfig);
    return carousel;
    
  } catch (e) { null; }
}

function destroyCarousel() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    
    if (carouselElement && carouselElement.swiper) {
      carouselElement.swiper.destroy(true, true);
    }
  } catch (e) { null; }
}

function handleCarouselResize() {
  try {
    if (isMobile()) {
      if (!carouselExists()) {
        initializeCarousel();
      }
    } else {
      if (carouselExists()) {
        destroyCarousel();
      }
    }
  } catch (e) { null; }
}


function initializeMobileCarousel() {
  try {
    if (isMobile()) {
      initializeCarousel();
    }
    } catch (e) { null; }
}


function setupEventListeners() {
  try {
    window.addEventListener('resize', handleCarouselResize);
  } catch (error) {null; }
}


function init() {
  try {
    initializeMobileCarousel();
    setupEventListeners();
  } catch (e) { null; }
}

document.addEventListener('DOMContentLoaded', init);

  } catch(e) { console.error(e); }
})();
})();
